import LogoS from "../../../assets/images/6.png";
import "./index.scss";

const Logo = () => {
  return (
    <div className="logo-container">
      <img
        draggable={false}
        className="solid-logo"
        src={LogoS}
        alt="JavaScript, Developer"
      />
    </div>
  );
};

export default Logo;
